<template>
  <el-card class="card" :bodyStyle="{ height: '100%' }">
    <div class="cardBody">
      <div
        style="
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        "
      >
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="散拍价格" prop="SPJG">
            <el-input
              v-model="ruleForm.SPJG"
              autocomplete="off"
              placeholder="请输入散拍价格..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="校拍价格" prop="XPJG">
            <el-input
              v-model="ruleForm.XPJG"
              placeholder="请输入校拍价格..."
              autocomplete="off"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="报告参考阈值" prop="reportReferenceScore">
            <el-input-number
              v-model="ruleForm.reportReferenceScore"
              :min="0"
              :max="100"
              :precision="2"
              :step="1"
              controls-position="right"
              size="small"
            />
            <div class="report-score-tip">
              三组比对共用；保存后用于新批次，已开始的批次及其重试保持原阈值。
            </div>
          </el-form-item>
          <el-form-item label="用户须知" prop="userXZ">
            <el-input
              v-model="ruleForm.userXZ"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="预约须知" prop="subscribeXZ">
            <el-input
              v-model="ruleForm.subscribeXZ"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="重拍说明" prop="CPSM">
            <el-input
              v-model="ruleForm.CPSM"
              type="textarea"
              placeholder="请输入重拍说明..."
              :autosize="{ minRows: 6, maxRows: 10 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="客服电话" prop="KFDH">
            <el-input
              v-model="ruleForm.KFDH"
              type="textarea"
              placeholder="请输入客服电话..."
            ></el-input>
          </el-form-item>
          <el-form-item label="隐私协议" prop="YSXY">
            <el-input
              v-model="ruleForm.YSXY"
              type="textarea"
              placeholder="请输入隐私协议..."
              :autosize="{ minRows: 6, maxRows: 10 }"
            ></el-input>
          </el-form-item>
          <el-form-item label="默认联系人" prop="centerContact">
            <el-input
              v-model="ruleForm.centerContact"
              autocomplete="off"
              placeholder="请输入默认联系人..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="默认联系电话" prop="centerPhone">
            <el-input
              v-model="ruleForm.centerPhone"
              autocomplete="off"
              placeholder="请输入默认联系电话..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="默认联系地址" prop="centerAddress">
            <el-input
              v-model="ruleForm.centerAddress"
              autocomplete="off"
              placeholder="请输入默认联系地址..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="默认电子邮箱" prop="centerEmail">
            <el-input
              v-model="ruleForm.centerEmail"
              autocomplete="off"
              placeholder="请输入默认电子邮箱..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="分社名称" prop="centerName">
            <el-input
              v-model="ruleForm.centerName"
              autocomplete="off"
              placeholder="请输入分社名称..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="默认卡号" prop="centerNo">
            <el-input
              v-model="ruleForm.centerNo"
              autocomplete="off"
              placeholder="请输入默认卡号..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="支付类型">
            <el-radio-group v-model="ruleForm.acquiescencepay">
              <el-radio label="1">工行支付</el-radio>
              <el-radio label="2">微信支付</el-radio>
              <el-radio label="3">自选支付</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="i豆支付" v-if="iDouBusConfig">
            <el-radio-group v-model="ruleForm.idouChange">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否强制使用i豆" v-if="iDouBusConfig">
            <el-radio-group v-model="ruleForm.displayContent.isCoerce">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="e支付用户勾选配置内容" v-if="iDouBusConfig">
            <el-input
              v-model.number="ruleForm.displayContent.displayContent"
              :disabled="ruleForm.displayContent.isCoerce == 1"
              autocomplete="off"
              placeholder="e支付页面配置显示的供用户勾选文本"
            ></el-input>
          </el-form-item>
          <el-form-item label="i豆兑付数" v-if="iDouBusConfig">
            <el-input
              v-model.number="ruleForm.payoutIDou"
              autocomplete="off"
              placeholder="每次i豆兑付数"
              @input="handleInputCalculate('all')"
            ></el-input>
          </el-form-item>
          <el-form-item label="散拍i豆兑付比例" v-if="iDouBusConfig">
            <div class="row-flex">
              <div class="item">
                <el-input
                  v-model="ruleForm.scatteredIDouSettlement.rate"
                  autocomplete="off"
                  placeholder="输入兑付比例"
                  @input="handleInputCalculate('scatteredIDouSettlement')"
                >
                  <template slot="prepend">兑付比例</template>
                  <template slot="append">%</template>
                </el-input>
              </div>
              <div class="item">
                <el-input
                  v-model="ruleForm.scatteredIDouSettlement.singleDiscountAmt"
                  autocomplete="off"
                  placeholder="请输入计算对应单笔减免金额"
                >
                  <template slot="prepend">计算对应单笔减免金额</template>
                </el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="校拍i豆兑付比例" v-if="iDouBusConfig">
            <div class="row-flex">
              <div class="item">
                <el-input
                  v-model="ruleForm.schoolIDouSettlement.rate"
                  autocomplete="off"
                  placeholder="输入兑付比例"
                  @input="handleInputCalculate('schoolIDouSettlement')"
                >
                  <template slot="prepend">兑付比例</template>
                  <template slot="append">%</template>
                </el-input>
              </div>
              <div class="item">
                <el-input
                  v-model="ruleForm.schoolIDouSettlement.singleDiscountAmt"
                  autocomplete="off"
                  placeholder="请输入计算对应单笔减免金额"
                >
                  <template slot="prepend">计算对应单笔减免金额</template>
                </el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="i豆商户兑付配置"
            v-if="iDouBiLiConfig"
            style="margin-bottom: 0"
          >
            <div
              class="row-flex three-box"
              v-for="(item, index) in ruleForm.idouMerchantConfig"
              :key="index"
            >
              <div class="item">
                <el-input
                  v-model="item.merchantNo"
                  autocomplete="off"
                  placeholder="请输入商户号"
                />
              </div>
              <div class="item">
                <el-input
                  v-model="item.deductionAmount"
                  autocomplete="off"
                  placeholder="请输入抵扣豆"
                />
              </div>
              <div class="item">
                <el-input
                  v-model="item.remark"
                  autocomplete="off"
                  placeholder="请输入备注"
                />
              </div>
              <div class="item btns">
                <i
                  class="el-icon-top"
                  @click.stop="handleMoveUp(index)"
                  title="上移"
                  v-if="index !== 0"
                  >上移</i
                >
                <i
                  class="el-icon-bottom"
                  @click.stop="handleMoveDown(index)"
                  title="下移"
                  v-if="index !== ruleForm.idouMerchantConfig.length - 1"
                  >下移</i
                >
                <i
                  class="el-icon-delete"
                  @click.stop="handleDelete(index)"
                  title="删除"
                  v-if="ruleForm.idouMerchantConfig.length > 1"
                  >删除</i
                >
                <i
                  class="el-icon-plus"
                  @click.stop="handleAdd"
                  title="添加"
                  v-if="index === 0"
                  >添加</i
                >
              </div>
            </div>
            <div style="color: gray">
              配置最终结果：i豆兑付数{{ ruleForm.payoutIDou }}，商户入账合计{{
                iDouBusConfigText
              }}，用户侧结余{{ ruleForm.payoutIDou - iDouBusConfigText }}
            </div>
          </el-form-item>

          <el-form-item label="照片查看方式">
            <el-radio-group v-model="ruleForm.checkType">
              <el-radio label="2">云盘查看</el-radio>
              <el-radio label="0">小程序查看</el-radio>
              <el-radio label="1">不查看</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备用支付">
            <el-radio-group v-model="ruleForm.havebackup">
              <el-radio label="1">启用</el-radio>
              <el-radio label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否开启散拍">
            <el-radio-group v-model="ruleForm.isSp">
              <el-radio label="1">启用</el-radio>
              <el-radio label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否运行小程序上传采集码">
            <el-radio-group v-model="ruleForm.isUpload">
              <el-radio label="1">启用</el-radio>
              <el-radio label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否开启采集端版本验证">
            <el-radio-group v-model="ruleForm.isVersion">
              <el-radio label="1">启用</el-radio>
              <el-radio label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="采集端版本号" prop="versionNo">
            <el-input
              v-model="ruleForm.versionNo"
              autocomplete="off"
              placeholder="请输入采集端版本号，（例：V2.0.0）"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="摄影师">
            <el-tag
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="showInput"
              v-model="inputValue"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
              placeholder="摄影师"
              style="width: 100px"
            >
            </el-input>
            <el-button
              class="button-new-tag"
              size="small"
              v-if="!showInput"
              @click="showInput = true"
              >添加摄影师</el-button
            >
          </el-form-item>
          <el-form-item label="默认密码接收手机号" prop="passwordMobile">
            <el-input
              v-model="ruleForm.passwordMobile"
              autocomplete="off"
              placeholder="请输入默认密码接收手机号..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="默认邮政编码" prop="postalCode">
            <el-input
              v-model="ruleForm.postalCode"
              autocomplete="off"
              placeholder="请输入默认邮政编码..."
              :rows="4"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>

        <div style="display: flex; justify-content: flex-end">
          <el-button
            v-if="submit"
            style="width: 131px; margin-bottom: 20px"
            type="primary"
            @click="submitForm()"
            size="small"
            >更新
          </el-button>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { queryParam, updateParam } from "../../../api/param.js";
import { queryPageButton } from "@/api/permission";

export default {
  name: "ParamSet",
  data() {
    var res = /^[0-9]+(\.[0-9]{2})?$/;
    const validateReportReferenceScore = (rule, value, callback) => {
      if (typeof value !== "number" || !Number.isFinite(value)) {
        callback(new Error("请输入报告参考阈值"));
        return;
      }
      if (value < 0 || value > 100) {
        callback(new Error("报告参考阈值必须在 0 至 100 之间"));
        return;
      }
      callback();
    };
    var validateSPJG = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入散拍价格"));
      } else {
        if (res.test(value) == false) {
          callback(new Error("格式不正确"));
        }
        callback();
      }
    };

    var validateXPJG = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入校拍价格"));
      } else {
        if (res.test(value) == false) {
          callback(new Error("格式不正确"));
        }
        callback();
      }
    };

    var validateuserXZ = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户说明"));
      } else {
        callback();
      }
    };

    var validatesubscribeXZ = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入预约说明"));
      } else {
        callback();
      }
    };

    var validateCPSM = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入重拍说明"));
      } else {
        callback();
      }
    };

    var validateKFDH = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入客户电话"));
      } else {
        callback();
      }
    };

    var validateYSXY = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入隐私协议"));
      } else {
        callback();
      }
    };
    var validateCenterContact = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入默认联系人"));
      } else {
        callback();
      }
    };
    var validateCenterPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入默认联系电话"));
      } else {
        callback();
      }
    };
    var validateCenterAddress = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入默认联系地址"));
      } else {
        callback();
      }
    };
    var validateCenterEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入默认电子邮箱"));
      } else {
        callback();
      }
    };
    var validateCenterName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入分社名称"));
      } else {
        callback();
      }
    };
    var validateCenterNo = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入默认卡号"));
      } else {
        callback();
      }
    };
    var validatePasswordMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入默认密码接收手机号"));
      } else {
        callback();
      }
    };
    var validatePostalCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入默认邮政编码"));
      } else {
        callback();
      }
    };
    return {
      dynamicTags: [],
      showInput: false,
      inputValue: "",
      ruleForm: {
        SPJG: "",
        XPJG: "",
        reportReferenceScore: 85,
        userXZ: "",
        subscribeXZ: "",
        CPSM: "",
        KFDH: "",
        YSXY: "",
        centerContact: "",
        centerPhone: "",
        centerAddress: "",
        centerEmail: "",
        centerName: "",
        centerNo: "",
        passwordMobile: "",
        postalCode: "",
        acquiescencepay: "1",
        idouChange: "1",
        displayContent: {},
        payoutIDou: "0",
        //散拍I豆兑付比例
        scatteredIDouSettlement: {
          rate: "0.0067",
          singleDiscountAmt: "0.09",
        },
        //校拍I豆兑付比例
        schoolIDouSettlement: {
          rate: "0.0067",
          singleDiscountAmt: "0.09",
        },
        //I豆商户兑付配置
        idouMerchantConfig: [
          {
            priority: 1,
            merchantNo: "",
            deductionAmount: 0,
            remark: "",
          },
          {
            priority: 1,
            merchantNo: "",
            deductionAmount: 0,
            remark: "",
          },
        ],
        checkType: "1",
        havebackup: "0",
        isSp: "0",
        isUpload: "0",
        isVersion: "1",
        versionNo: "",
      },
      dialogVisible: false,
      rules: {
        reportReferenceScore: [
          { validator: validateReportReferenceScore, trigger: "change" },
        ],
        SPJG: [
          {
            validator: validateSPJG,
            trigger: "blur",
          },
        ],
        XPJG: [
          {
            validator: validateXPJG,
            trigger: "blur",
          },
        ],
        userXZ: [
          {
            validator: validateuserXZ,
            trigger: "blur",
          },
        ],
        subscribeXZ: [
          {
            validator: validatesubscribeXZ,
            trigger: "blur",
          },
        ],
        CPSM: [
          {
            validator: validateCPSM,
            trigger: "blur",
          },
        ],
        KFDH: [
          {
            validator: validateKFDH,
            trigger: "blur",
          },
        ],
        YSXY: [
          {
            validator: validateYSXY,
            trigger: "blur",
          },
        ],
        centerContact: [
          {
            validator: validateCenterContact,
            trigger: "blur",
          },
        ],
        centerPhone: [
          {
            validator: validateCenterPhone,
            trigger: "blur",
          },
        ],
        centerAddress: [
          {
            validator: validateCenterAddress,
            trigger: "blur",
          },
        ],
        centerEmail: [
          {
            validator: validateCenterEmail,
            trigger: "blur",
          },
        ],
        centerName: [
          {
            validator: validateCenterName,
            trigger: "blur",
          },
        ],
        centerNo: [
          {
            validator: validateCenterNo,
            trigger: "blur",
          },
        ],
        passwordMobile: [
          {
            validator: validatePasswordMobile,
            trigger: "blur",
          },
        ],
        postalCode: [
          {
            validator: validatePostalCode,
            trigger: "blur",
          },
        ],
      },

      submit: false,
      iDouBusConfig: false, //i豆商户兑付配置
      iDouBiLiConfig: false, //i豆兑付比例配置
    };
  },
  created() {
    this.queryButton();
    this.query();
  },
  computed: {
    //计算i豆商户兑付配置
    iDouBusConfigText() {
      let deductionAmount = 0;
      this.ruleForm.idouMerchantConfig.forEach((item) => {
        deductionAmount += Number(item.deductionAmount);
      });
      return deductionAmount;
    },
  },
  methods: {
    queryButton() {
      const data = 16;
      queryPageButton(data).then((resp) => {
        for (const button of resp.data) {
          if (button.code === "submit") {
            this.submit = true;
          }
          if (button.code === "iDouBusConfig") {
            this.iDouBusConfig = true;
          }
          if (button.code === "iDouBiLiConfig") {
            this.iDouBiLiConfig = true;
          }
        }
      });
    },
    query() {
      queryParam()
        .then((resp) => {
          // console.debug('idouMerchantConfig',resp.data.idouMerchantConfig);
          this.ruleForm.XPJG = resp.data.schoolAuctionPrice;
          this.ruleForm.SPJG = resp.data.scatteredAuctionPrice;
          this.ruleForm.reportReferenceScore =
            resp.data.reportReferenceScore ?? 85;
          this.ruleForm.userXZ = resp.data.userInstructions;
          this.ruleForm.subscribeXZ = resp.data.bookingInstructions;
          this.ruleForm.CPSM = resp.data.remakeDescription;
          this.ruleForm.KFDH = resp.data.kefudianhua;
          this.ruleForm.YSXY = resp.data.yinsixieyi;
          this.ruleForm.acquiescencepay = resp.data.acquiescencepay; //支付类型，1工行支付，2微信支付
          this.ruleForm.idouChange = resp.data.idouChange; //不豆支付
          this.ruleForm.displayContent = JSON.parse(resp.data.displayContent); //每次i豆兑付数
          this.ruleForm.payoutIDou = resp.data.payoutIDou; //每次I豆兑付数
          //散拍I豆兑付比例
          this.ruleForm.scatteredIDouSettlement = JSON.parse(
            resp.data.scatteredIDouSettlement
          );
          //校拍I豆兑付比例
          this.ruleForm.schoolIDouSettlement = JSON.parse(
            resp.data.schoolIDouSettlement
          );
          //I豆商户兑付配置
          this.ruleForm.idouMerchantConfig = JSON.parse(
            resp.data.idouMerchantConfig
          );
          this.ruleForm.checkType = resp.data.checkType; //照片查看方式，0小程序查看，1不查看，2云盘查看
          this.ruleForm.havebackup = resp.data.havebackup;
          this.ruleForm.isSp = resp.data.isSp;
          this.ruleForm.isUpload = resp.data.isUpload;
          this.ruleForm.centerContact = resp.data.centerContact;
          this.ruleForm.centerPhone = resp.data.centerPhone;
          this.ruleForm.centerAddress = resp.data.centerAddress;
          this.ruleForm.centerEmail = resp.data.centerEmail;
          this.ruleForm.centerName = resp.data.centerName;
          this.ruleForm.centerNo = resp.data.centerNo;
          this.ruleForm.passwordMobile = resp.data.passwordMobile;
          this.ruleForm.postalCode = resp.data.postalCode;
          this.ruleForm.isVersion = resp.data.isVersion ?? "1";
          this.ruleForm.versionNo = resp.data.versionNo;
          // console.debug(this.ruleForm)

          if (resp.data.photographer) {
            this.dynamicTags = resp.data.photographer.split(",");
          }
        })
        .catch((e) => {
          console.log(e.responseText);
        });
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.iDouBusConfigText > this.ruleForm.payoutIDou) {
            this.$message.error("i豆商户兑付配置总合不能大于i豆兑付数");
            return false;
          }
          const paramruleForm = {
            schoolAuctionPrice: this.ruleForm.XPJG,
            scatteredAuctionPrice: this.ruleForm.SPJG,
            reportReferenceScore: this.ruleForm.reportReferenceScore,
            userInstructions: this.ruleForm.userXZ,
            bookingInstructions: this.ruleForm.subscribeXZ,
            remakeDescription: this.ruleForm.CPSM,
            kefudianhua: this.ruleForm.KFDH,
            yinsixieyi: this.ruleForm.YSXY,
            acquiescencepay: this.ruleForm.acquiescencepay,
            idouChange: this.ruleForm.idouChange,
            displayContent: JSON.stringify(this.ruleForm.displayContent), //每次i豆兑付数
            payoutIDou: this.ruleForm.payoutIDou,
            //散拍I豆兑付比例
            scatteredIDouSettlement: JSON.stringify(
              this.ruleForm.scatteredIDouSettlement
            ),
            //校拍I豆兑付比例
            schoolIDouSettlement: JSON.stringify(
              this.ruleForm.schoolIDouSettlement
            ),
            //I豆商户兑付配置
            idouMerchantConfig: JSON.stringify(
              this.ruleForm.idouMerchantConfig
            ),

            checkType: this.ruleForm.checkType,
            havebackup: this.ruleForm.havebackup,
            isSp: this.ruleForm.isSp,
            isUpload: this.ruleForm.isUpload,

            centerContact: this.ruleForm.centerContact,
            centerPhone: this.ruleForm.centerPhone,
            centerAddress: this.ruleForm.centerAddress,
            centerEmail: this.ruleForm.centerEmail,
            centerName: this.ruleForm.centerName,
            centerNo: this.ruleForm.centerNo,
            passwordMobile: this.ruleForm.passwordMobile,
            postalCode: this.ruleForm.postalCode,
            isVersion: this.ruleForm.isVersion,
            versionNo: this.ruleForm.versionNo,
          };
          if (this.dynamicTags.length) {
            paramruleForm.photographer = this.dynamicTags.join(",");
          }
          updateParam(paramruleForm)
            .then((resp) => {
              this.$notify({
                title: "修改成功",
                message: resp.message,
                type: "success",
              });
            })
            .catch((e) => {
              console.log(e.responseText);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.showInput = false;
      this.inputValue = "";
    },
    handleInputCalculate(type = "all") {
      const { payoutIDou, scatteredIDouSettlement, schoolIDouSettlement } =
        this.ruleForm;
      // 银行家舍入法函数
      const bankerRound = (num, decimals = 0) => {
        const p = Math.pow(10, decimals);
        const n = num * p * (1 + Number.EPSILON);
        const i = Math.floor(n);
        const f = n - i;
        const e = 1e-10;
        if (Math.abs(f - 0.5) < e) {
          return i % 2 == 0 ? i / p : (i + 1) / p;
        } else {
          return Math.round(n) / p;
        }
      };
      // 计算i豆兑付结果的通用方法
      const calculateIDouSettlement = (idouAmount, rate) => {
        //(i豆兑付数/1000) * (兑付比例 / 100)
        const rawResult = (idouAmount / 1000) * (rate / 100);
        return bankerRound(rawResult, 2).toFixed(2);
      };
      switch (type) {
        case "all":
          scatteredIDouSettlement.singleDiscountAmt = calculateIDouSettlement(
            payoutIDou,
            scatteredIDouSettlement.rate
          );
          schoolIDouSettlement.singleDiscountAmt = calculateIDouSettlement(
            payoutIDou,
            schoolIDouSettlement.rate
          );
          break;
        case "scatteredIDouSettlement": //散拍i豆兑付比例
          scatteredIDouSettlement.singleDiscountAmt = calculateIDouSettlement(
            payoutIDou,
            scatteredIDouSettlement.rate
          );
          break;
        case "schoolIDouSettlement": //校拍i豆兑付比例
          schoolIDouSettlement.singleDiscountAmt = calculateIDouSettlement(
            payoutIDou,
            schoolIDouSettlement.rate
          );
          break;
      }
    },
    //添加
    handleAdd() {
      this.ruleForm.idouMerchantConfig.push({
        priority: this.ruleForm.idouMerchantConfig.length + 1,
        merchantNo: "",
        deductionAmount: 0,
        remark: "",
      });
    },
    //删除
    handleDelete(index) {
      if (this.ruleForm.idouMerchantConfig.length <= 1) {
        this.$message.warning("至少保留一项配置");
        return;
      }
      this.ruleForm.idouMerchantConfig.splice(index, 1);
      // 更新优先级
      this.updatePriority();
    },
    //上移
    handleMoveUp(index) {
      if (index === 0) return;
      const temp = this.ruleForm.idouMerchantConfig[index];
      this.$set(
        this.ruleForm.idouMerchantConfig,
        index,
        this.ruleForm.idouMerchantConfig[index - 1]
      );
      this.$set(this.ruleForm.idouMerchantConfig, index - 1, temp);
      // 更新优先级
      this.updatePriority();
    },
    //下移
    handleMoveDown(index) {
      if (index === this.ruleForm.idouMerchantConfig.length - 1) return;
      const temp = this.ruleForm.idouMerchantConfig[index];
      this.$set(
        this.ruleForm.idouMerchantConfig,
        index,
        this.ruleForm.idouMerchantConfig[index + 1]
      );
      this.$set(this.ruleForm.idouMerchantConfig, index + 1, temp);
      // 更新优先级
      this.updatePriority();
    },
    //更新优先级
    updatePriority() {
      this.ruleForm.idouMerchantConfig.forEach((item, index) => {
        item.priority = index + 1;
      });
    },
  },
};
</script>

<style scoped>
.report-score-tip {
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}

.card {
  height: calc(100vh - 145px);
  overflow-y: auto;
}

.cardBody {
  height: calc(100% - 40px);
}

.el-tag--light {
  margin-right: 5px;
}

.row-flex {
  display: flex;

  .item {
    flex: 1;

    &:first-child {
      margin-right: 6px;
    }

    &:last-child {
      margin-left: 6px;
    }

    &.btns {
      flex: none;
      width: 129px;
      box-sizing: border-box;

      i {
        color: #446cf3;
        font-size: 13px;
        margin-right: 6px;
        cursor: pointer;

        &:last-child {
          margin-right: 0px;
        }

        &.el-icon-delete {
          color: #ff2b2b;
        }
      }
    }
  }

  &.three-box {
    padding-bottom: 15px;

    &:last-child {
      padding-bottom: 0px;
    }

    .item:nth-child(2),
    .item:nth-child(3) {
      margin: 0 6px;
    }
  }
}
</style>
